function ColorServiceFn() {
  class ColorService {
    rgbToHex(r, g, b) { //eslint-disable-line
      return '#' + _componentToHex(r) + _componentToHex(g) + _componentToHex(b); //eslint-disable-line
    }
  }

  function _componentToHex(c) {
    if (c === null || c === undefined) c = 0;
    const hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex; //eslint-disable-line
  }

  return new ColorService();
}

export default ColorServiceFn;



// WEBPACK FOOTER //
// ./src/services/colorService.js